/**
 * Alpine x directive utility for dispatching Alpine events on DOM change within the context of a
 * FormBuilder form
 */

/**
 * DispatchEventsFormBuilder x-directive
 */
const DispatchEventsFormBuilder = function(el, { value, modifiers, expression }, { Alpine }) {
  /**
   * Observer for all child elements of the x-directive element
   */
  const domUpdateObserver = new MutationObserver((mutations, observer) => {
    mutations.forEach(mutation => {

      if (
        !mutation.addedNodes.length ||
        mutation.addedNodes.length > 1 ||
        mutation.addedNodes[0].nodeName !== 'DIV' ||
        !mutation.addedNodes[0].classList.contains('FormBuilder')
      ) {
        return;
      }

      const targetEl = mutation.addedNodes[0];
      const errors = targetEl.querySelectorAll('.FormBuilderErrors .error');

      if (!errors) {
        return;
      }

      const formEl = targetEl.querySelector('form');

      if (!formEl) {
        return;
      }

      const formbuilderEvent = new CustomEvent('formbuilder-event', {
        detail: {
          formId: formEl.id,
          submissionErrors: errors.length,
        }
      });

      el.dispatchEvent(formbuilderEvent);
    });
  });

  domUpdateObserver.observe(el, {childList: true, subtree: true});
}

export default DispatchEventsFormBuilder;
